import { render, staticRenderFns } from "./CCustomCheckbox.vue?vue&type=template&id=cb1225d8&scoped=true"
import script from "./CCustomCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CCustomCheckbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CCustomCheckbox.vue?vue&type=style&index=0&id=cb1225d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1225d8",
  null
  
)

export default component.exports